import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchCheckEstimationExists,
  TCheckEstimationExistsResponse,
} from 'shared/repositories/price-estimator/v5/check-estimation-exists';
import { IApplicationContext } from 'shared/types/applicationContext';

export const fetchEstimationExist = async (context: IApplicationContext, address: string) => {
  try {
    const res = (await fetchCheckEstimationExists({
      httpApi: context.httpApi,
      parameters: { address },
    })) as TCheckEstimationExistsResponse;

    if (res.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: res.statusCode,
        domain: 'getEstimationExist.ts',
        message: res.response.message,
      });
    }

    return res.response.saleEstimationExists;
  } catch (error) {
    context.logger.error(error, { message: 'Error in fetchIsMyHomeObjectsExist' });

    return false;
  }
};
